import { CKLayoutVertical, CKRadioGroup, CKRadioNext } from 'clearkit';

export interface CreditOption {
  value: string;
  credits: string;
  cost: number;
}

interface CreditSelectorProps {
  options: CreditOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const CreditSelector: React.FC<CreditSelectorProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  const radioBoxStyles =
    'ck-box px-6 py-4 ck-focus-ring hover:border-blue hover:bg-blue-50 cursor-pointer w-full flex flex-row flex-start';

  return (
    <CKRadioGroup containerClassName="gap-6" onChange={onChange} value={value}>
      <CKRadioGroup.Label className="mb-4">Credits</CKRadioGroup.Label>
      {options.map((option) => (
        <CKRadioNext
          className={className || radioBoxStyles}
          gap=".25rem"
          key={option.value}
          value={option.value}
        >
          <CKLayoutVertical as="span" gap="0">
            <span className="font-semibold">{option.credits}</span>
            <span className="text-gray-500">${option.cost}/month</span>
          </CKLayoutVertical>
        </CKRadioNext>
      ))}
    </CKRadioGroup>
  );
};
